import styles from "./participants.module.css";

export default function Participants({ currentRegistrations, maxPlayers }) {
  const safeCurrentRegistrations = Math.max(0, currentRegistrations ?? 0);
  const safeMaxPlayers = Math.max(0, maxPlayers ?? 0);
  const safeSlotsAvailable = Math.max(
    0,
    safeMaxPlayers - safeCurrentRegistrations,
  );
  const safeFilledPercent =
    safeMaxPlayers > 0
      ? Math.min(
          100,
          Math.max(0, (safeCurrentRegistrations / safeMaxPlayers) * 100),
        )
      : 0;

  return (
    <div className={styles.participantsCard}>
      <h2 className={styles.sectionTitle}>Registration Status</h2>

      <div className={styles.availabilityBox}>
        <div className={styles.availabilityItem}>
          <span className={styles.label}>Slots Filled</span>
          <span className={styles.value}>{safeCurrentRegistrations}</span>
        </div>

        <div className={styles.availabilityItem}>
          <span className={styles.label}>Slots Available</span>
          <span className={styles.value}>{safeSlotsAvailable}</span>
        </div>
      </div>

      <div className={styles.filledPercentage}>
        <span>{Math.round(safeFilledPercent)}% filled</span>
      </div>

      {safeMaxPlayers > 0 &&
        safeCurrentRegistrations < safeMaxPlayers * 0.8 && (
          <div className={styles.urgencyMessage}>
            Still {safeSlotsAvailable} slots available - Register now!
          </div>
        )}

      {safeMaxPlayers > 0 &&
        safeCurrentRegistrations >= safeMaxPlayers * 0.8 && (
          <div className={styles.urgencyMessage} style={{ color: "#ff6b6b" }}>
            Almost full! Only {safeSlotsAvailable} slots left.
          </div>
        )}
    </div>
  );
}
